import { isZoomApp, openUrlFromWeb } from "@utils/helpers";
import { openURLFromZoom, inviteParticipantsToApp } from "@sdk/zoom/utils";

const zoomAppUtils =  {
  openUrl: openURLFromZoom,
  inviteParticipantsToApp,
};

const webUtils =  {
  openUrl: openUrlFromWeb,
}

const useSdkUtils = () => {
  const sdkUtils = isZoomApp ? zoomAppUtils : webUtils;

  return { ...sdkUtils };
}

export default useSdkUtils;
